<template>
  <div>
    <!-- 问题反馈注释  -->
    <van-nav-bar
      safe-area-inset-top
      left-arrow
      @click-left="onClickLeft"
      title="历史记录"
      fixed
    />
    <van-row safe-area-inset-top class="search-input">
        <van-col span="24">
          <van-tabs v-model="activeName" color="#1989fa" title-inactive-color="rgb(188, 188, 188)" title-active-color="#1989fa" @change="onClickTab">
            <van-tab title="配方浏览记录" name="browsingHistory">

              <div class="search-dev">
                <van-list
                    v-model="historyLoading"
                    :finished="historyFinished"
                    finished-text="没有更多了"
                  >
                  <div class="order-box"  @click="orderClick(item)" v-for="(item,index) in browsingHistoryList" :key="index">
                    <div class="div-box-txt">
                      <div class="d1">
                        <!-- colorSpecial 值为10071004:素色时不渐变，其他渐变 -->
                        <div class="d1-title1" :style="item.colorSpecial!=10071004?'background-color:'+item.colorRgb+';background-image: linear-gradient('+item.gcColorRgb+','+item.colorRgb+','+item.colorRgb+','+item.gcColorRgb+')':'background-color:' +item.colorRgb"></div>

                        <div class="d1-title2">
                          <div class="d1-title1-txt1">
                            <van-row justify="end">
                              <van-col class="env-col"></van-col>
                              <van-col span="15">
                                <span class="txt-span">{{item.colorCode}} {{item.colorName}}</span>
                                <van-icon v-if="item.collectionTime == null" size="1.2rem" color="rgb(204,204,204)" name="star" />
                                <van-icon v-else size="1.2rem" color="rgb(254,200,9)" name="star" />
                              </van-col>
                              <van-col style="blackgroun:red;" span="8">
                                <!-- <img class="img-log" :src="item.paintBrandUrl" alt=""> -->
                                <img class="img-log" v-if="item.paintBrandCode ==='NBW' || item.paintBrandCode ==='NBS1K' || item.paintBrandCode ==='NBS2K'" src="../../assets/image/brand2.png" alt="">
                                <img class="img-log" v-else src="../../assets/image/brand1.png" alt="">
                              </van-col>
                            </van-row>
                            <van-row style="margin-top:2px;">
                              <van-col span="24">
                                <div style="margin-left: 10px" v-if="item.avgScore>0">
                                  <img
                                    v-for="(item, index) in historyCommentLevelImg[index]"
                                    :src="item.url"
                                    :key="index"
                                    class="img-styles"
                                    alt=""
                                  />
                                  <span style="margin: 1px 0 0 8px;font-size:13px">{{item.avgScore}}分</span>
                                </div>
                                <div style="margin-left: 10px" v-else>
                                  <span style="margin: 1px 0 0;font-size:13px">暂无评分</span>
                                </div>
                              </van-col>
                            </van-row>
                            <div class="div-end">
                              <div class="div-end-d1">
                                <div class="icon-circle">
                                  <span class="icon-circle-class">{{item.recipeLabel}}</span>
                                </div>
                                <div class="icon-circleTwo">
                                  <span class="icon-circle-class">{{item.paintBrandLabel}}</span>
                                </div>
                                <div class="icon-circleThree" v-if="item.collectionCount>0">
                                  <span class="icon-circle-class">{{item.collectionCount}}次收藏</span>
                                </div>
                              </div>
                              <div class="div-end-d2">
                                <div v-if="item.photo === null || item.photo === ''" class="icon-imgs-style">
                                  <span  style="font-size:13px;color:rgb(0,145,220)">暂无图片</span>
                                </div>
                                <div @click.stop="imgClick(item)" v-else class="icon-imgs-style">
                                  <van-icon name="photo-o" />
                                  <span color='rgb(0,145,220)' style="font-size:13px;color:rgb(0,145,220);padding: 0px 3px;">
                                    预览
                                  </span>
                                  <div id="triangle-right"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d2">
                        <van-row class="van-rows">
                          <van-col class="env-col" span="2"></van-col>
                          <van-col span="20">
                            <div class="span-h3-box">
                              <img style="height:1.3rem;position: relative;top:3px;" src="../../assets/image/vehicleIcon.png" alt="">
                              <span class="span-h3">{{item.carBrandName}} - {{item.carModelName}}</span>
                              <!-- <span class="span-h3">{{item.carBrandName}} - {{item.carModelName}}  ({{item.recipeYear}})</span> -->
                              <!-- <span v-for="(item,index) in 20" :key="index" class="span-h3">,还有谁</span> -->
                            </div>
                          </van-col>
                        </van-row>
                        <van-row class="van-rows">
                          <van-col class="env-col" span="2"></van-col>
                          <van-col span="4">
                            <span class="span-min">上传时间</span>
                          </van-col>
                          <van-col span="8">
                          <span class="span-min">{{item.uploadTimeStr}}</span>
                        </van-col>
                          <van-col span="4">
                            <span class="span-min">上传地域 </span>
                          </van-col>
                          <van-col span="4">
                            <span class="span-colorOne">{{item.uploadRegionName}}</span>
                          </van-col>
                        </van-row>
                        <van-row class="van-rows"> 
                          <van-col class="env-col" span="2"></van-col>
                          <van-col span="4">
                            <span class="span-min">适用车龄</span>
                          </van-col>
                          <van-col span="8">
                            <span class="span-colorOne">{{item.carAgeDesc}}</span> 
                          </van-col>
                          <van-col span="4">
                            <span  class="span-min">车型年款</span>
                          </van-col>
                          <van-col span="4">
                            <span class="span-colorOne">{{item.recipeYear}}</span>
                          </van-col>
                        </van-row>
                        <van-row class="van-rows"> 
                          <van-col class="env-col" span="2"></van-col>
                          <van-col span="4">
                            <span class="span-min">调漆工序</span>
                          </van-col>
                          <van-col span="8">
                            <span class="span-colorOne">{{item.isThree==1 ?'多工序':'单工序' }}</span>
                          </van-col>
                          <van-col span="4">
                            <span  class="span-min">偏差描述</span>
                          </van-col>
                          <van-col span="4">
                            <span class="span-colorOne">{{item.deviantColor}}</span>
                          </van-col>
                        </van-row>
                      </div>
                    </div>
                  </div>
                </van-list>
              </div>
            </van-tab>
            <van-tab title="我的评论" name="myComment">
              <div class="search-dev">
                  <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
                  >
                  <!-- 单子 -->
                    <div v-for="(item,index) in recipeOrder.list" :key="index">
                      <div>
                        <van-row style="margin-top:10px;width: 90%;margin-left: 5%;">
                          <van-col span="14">
                            <div v-if="item.commentDetailsLevel>0">
                              <img
                                v-for="(item, index) in item.userImgUrlArrs"
                                :src="item.url"
                                :key="index"
                                class="img-styles"
                                alt=""
                              />
                            </div>
                          </van-col>
                          <van-col span="10" align="right">
                            <div>
                              <span style="margin: 1px 0 0;font-size:13px;color:#0092FF;">{{item.commentTime.substring(0,10)}}</span>
                            </div>
                          </van-col>
                        </van-row>
                      </div>
                      <div>
                        <van-row style="margin-top:10px;width: 90%;margin-left: 5%;" v-if="item.commentInfo">
                          <van-col span="24">

                            <div class="span-h3-box">
                              <span style="font-size:15px">{{item.commentInfo}}</span>
                            </div>
                          </van-col>
                        </van-row>
                      </div>
                      <div class="order-box"  @click="orderClick(item)" >
                        <div class="div-box-txt">
                          <div class="d1">
                            <!-- colorSpecial 值为10071004:素色时不渐变，其他渐变 -->
                            <div class="d1-title1" :style="item.colorSpecial!=10071004?'background-color:'+item.colorRgb+';background-image: linear-gradient('+item.gcColorRgb+','+item.colorRgb+','+item.colorRgb+','+item.gcColorRgb+')':'background-color:' +item.colorRgb"></div>

                            <div class="d1-title2">
                              <div class="d1-title1-txt1">
                                <van-row justify="end">
                                  <van-col class="env-col"></van-col>
                                  <van-col span="15">
                                    <span class="txt-span">{{item.colorCode}} {{item.colorName}}</span>
                                    <van-icon v-if="item.collectionTime == null" size="1.2rem" color="rgb(204,204,204)" name="star" />
                                    <van-icon v-else size="1.2rem" color="rgb(254,200,9)" name="star" />
                                  </van-col>
                                  <van-col style="blackgroun:red;" span="8">
                                    <!-- <img class="img-log" :src="item.paintBrandUrl" alt=""> -->
                                    <img class="img-log" v-if="item.paintBrandCode ==='NBW' || item.paintBrandCode ==='NBS1K' || item.paintBrandCode ==='NBS2K'" src="../../assets/image/brand2.png" alt="">
                                    <img class="img-log" v-else src="../../assets/image/brand1.png" alt="">
                                  </van-col>
                                </van-row>
                                <van-row style="margin-top:2px;">
                                  <van-col span="24">
                                    <div style="margin-left: 10px" v-if="item.avgScore>0">
                                      <img
                                        v-for="(item, index) in commentLevelImg[index]"
                                        :src="item.url"
                                        :key="index"
                                        class="img-styles"
                                        alt=""
                                      />
                                      <span style="margin: 1px 0 0 8px;font-size:13px">{{item.avgScore}}分</span>
                                    </div>
                                    <div style="margin-left: 10px" v-else>
                                      <span style="margin: 1px 0 0;font-size:13px">暂无评分</span>
                                    </div>
                                  </van-col>
                                </van-row>
                                <div class="div-end">
                                  <div class="div-end-d1">
                                    <div class="icon-circle">
                                      <span class="icon-circle-class">{{item.recipeLabel}}</span>
                                    </div>
                                    <div class="icon-circleTwo">
                                      <span class="icon-circle-class">{{item.paintBrandLabel}}</span>
                                    </div>
                                    <div class="icon-circleThree" v-if="item.collectionCount>0">
                                      <span class="icon-circle-class">{{item.collectionCount}}次收藏</span>
                                    </div>
                                  </div>
                                  <div class="div-end-d2">
                                    <div v-if="item.photo === null || item.photo === ''" class="icon-imgs-style">
                                      <span  style="font-size:13px;color:rgb(0,145,220)">暂无图片</span>
                                    </div>
                                    <div @click.stop="imgClick(item)" v-else class="icon-imgs-style">
                                      <van-icon name="photo-o" />
                                      <span color='rgb(0,145,220)' style="font-size:13px;color:rgb(0,145,220);padding: 0px 3px;">
                                        预览
                                      </span>
                                      <div id="triangle-right"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="d2">
                            <van-row class="van-rows">
                              <van-col class="env-col" span="2"></van-col>
                              <van-col span="20">
                                <div class="span-h3-box">
                                  <img style="height:1.3rem;position: relative;top:3px;" src="../../assets/image/vehicleIcon.png" alt="">
                                  <span class="span-h3">{{item.carBrandName}} - {{item.carModelName}}</span>
                                  <!-- <span class="span-h3">{{item.carBrandName}} - {{item.carModelName}}  ({{item.recipeYear}})</span> -->
                                  <!-- <span v-for="(item,index) in 20" :key="index" class="span-h3">,还有谁</span> -->
                                </div>
                              </van-col>
                            </van-row>
                            <van-row class="van-rows">
                              <van-col class="env-col" span="2"></van-col>
                              <van-col span="4">
                                <span class="span-min">上传时间</span>
                              </van-col>
                              <van-col span="8">
                              <span class="span-min">{{item.uploadTimeStr}}</span>
                            </van-col>
                              <van-col span="4">
                                <span class="span-min">上传地域 </span>
                              </van-col>
                              <van-col span="4">
                                <span v-if="item.uploadRegionName ===''"  class="span-colorOne" >通用</span>
                                <span v-else  class="span-colorOne" >{{item.uploadRegionName}}</span>
                              </van-col>
                            </van-row>
                            <van-row class="van-rows"> 
                              <van-col class="env-col" span="2"></van-col>
                              <van-col span="4">
                                <span class="span-min">适用车龄</span>
                              </van-col>
                              <van-col span="8">
                                <span class="span-colorOne">{{item.carAgeDesc}}</span> 
                              </van-col>
                              <van-col span="4">
                                <span  class="span-min">车型年款</span>
                              </van-col>
                              <van-col span="4">
                                <span class="span-colorOne">{{item.recipeYear}}</span>
                              </van-col>
                            </van-row>
                            <van-row class="van-rows"> 
                              <van-col class="env-col" span="2"></van-col>
                              <van-col span="4">
                                <span class="span-min">调漆工序</span>
                              </van-col>
                              <van-col span="8">
                                <span class="span-colorOne">{{item.isThree==1 ?'多工序':'单工序' }}</span>
                              </van-col>
                              <van-col span="4">
                                <span  class="span-min">偏差描述</span>
                              </van-col>
                              <van-col span="4">
                                <span class="span-colorOne">{{item.deviantColor}}</span>
                              </van-col>
                            </van-row>
                          </div>
                          
                        </div>
                      </div>

                      <div style="margin-top:20px;margin-bottom:5px;background-color:white;height:5px;width:100%;"></div>
                    </div>
                  </van-list>
              </div>
            </van-tab>
          </van-tabs>
        </van-col>
        <!-- <van-col @click="searchClick" class="search-btn" span="6">
            <div>
                搜索
            </div>
        </van-col> -->
    </van-row>
    <!-- 配方列表 -->
      
      <van-number-keyboard safe-area-inset-bottom />
      <!-- 图片预览 -->
      <van-image-preview v-model="showImg" :images="images" />

  </div>
</template>

<script>
import storeState from "../../store/index"; //storeId就是导出的那个值
import Api from "../../api/api";
import { Toast } from 'vant';
import {colorRgb } from "../../common/util.js";

const storeStates = storeState();
export default {
  name:"MyRecipeHistory",
  data() {
    return {
      radio: '1', // 组件参数,默认1
      showImg: false, // 图片预览是否显示
      images:[],// 图片列表
      index: null,
        searchVla:'', // 搜索
        // 配方参数
        // 查询配方列表 
      queryPageData: {
        // 当前页码
        page: 0,
        // 每页条数
        rows: 10,
        data:{
          keys: [],
          recipePageQueryType: '1',
          firstSort: "3"
        }
      },
      // 分页参数
       recipeOrder: {
        currPage: '',
        pageSize: 10,
        totalCount: '',
        totalPage: '',
        list:[],
      },

      finished: false,  // 分页是否加载完成
      loading: false, // 是否触发分页
      commentLevelImg: [
      ],
      
      radioShow: false,
      popupShow: false,
      activeName:"browsingHistory",//默认选中的tab
      historyFinished: false,  // 分页是否加载完成
      historyLoading: false, // 是否触发分页
      browsingHistoryList:[],//配方浏览记录列表
      historyCommentLevelImg:[], //历史记录评分图片
    };
  },
  mounted() {
    console.log("33333");
    // this.searchDetailsBrowsingHistoryList();

  },
  methods: {

    onLoad() {
        this.queryPageData.page += 1;
        // 进入首页，请求数据
        Api.queryUserCommentRecipePage(this.queryPageData).then((res) => {
          // this.loading = false;
          if (res.data.success) {
           this.loading = false;
           if (res.data.result.totalPage === 0) {
                this.finished = true;
            }
            console.log(res);
            this.recipeOrder.currPage = res.data.result.currPage;
            this.recipeOrder.pageSize = res.data.result.pageSize;
            this.recipeOrder.totalCount = res.data.result.totalCount;
            this.recipeOrder.totalPage = res.data.result.totalPage;
            
            for (let index = 0; index < res.data.result.list.length; index++) {
                
                // 评分
                let imgUrlArrs = [];
          
                let avgScores = res.data.result.list[index].avgScore
                let decimalPart = avgScores - Math.floor(avgScores);
                let lenghtOr =0;
                let halfFlag = false;
                if (0<decimalPart    && decimalPart < 0.5) {
                      lenghtOr=Math.floor(avgScores);
                } else if (decimalPart >= 0.5 && decimalPart < 0.9) {
                      lenghtOr=Math.floor(avgScores)+1;
                      halfFlag = true;
                } else {
                      lenghtOr=Math.floor(avgScores);
                }
        
                for (let index = 0; index < lenghtOr; index++) {
                      if(index+1== lenghtOr && halfFlag){
                        imgUrlArrs.push({ url: require("../../assets/image/scoreHalf.png") })
                      }else{
                        imgUrlArrs.push( { url: require("../../assets/image/scoreTrue.png") })
                      }
                    
                }
                this.commentLevelImg.push(imgUrlArrs)

                // 用户评分
                let userImgUrlArrs = [];
                for (let index1 = 0; index1 < res.data.result.list[index].commentDetailsLevel; index1++) {
                  userImgUrlArrs.push( { url: require("../../assets/image/scoreTrue.png") })
                }
                res.data.result.list[index].userImgUrlArrs=userImgUrlArrs;
                this.recipeOrder.list.push(res.data.result.list[index]);
                console.log("this.recipeOrder.list:",this.recipeOrder.list);

            }

            //获取色号值十六进制转换RGB值
            this.recipeOrder.list.forEach(item => {
              let colorObj=colorRgb(item.colorRgb?"#"+item.colorRgb:"");
              console.log("colorRgb:",colorObj);
              item.colorRgb=colorObj.colorRgb;
              item.gcColorRgb=colorObj.gcColorRgb;
            });
            
            console.log(this.queryPageData.page,res.data.result.totalPage);
            if (this.queryPageData.page == res.data.result.totalPage) {
                this.finished = true;
                console.log('数据总长',this.recipeOrder.list.length);
            }
            this.loading = false;
          }
          
        });
    },
    // 图片预览
    imgClick(item) {
      this.images = []
      this.showImg = true;
      let datas = {
        recipeNo: item.recipeNo
      }
      Api.recipeImg(datas).then((res) => {
        console.log(res.data.result.photo);
        this.images.push(res.data.result.photo)
      })
    },
    // 搜索输入框
    searchVlaInput() {
      this.searchVla = this.searchVla.replaceAll(" ","，");
      this.searchVla = this.searchVla.replaceAll("/","，");
      this.searchVla = this.searchVla.replaceAll("、","，");
      // console.log(this.queryPageData.data.keys.split('，'));
      this.queryPageData.data.keys = this.searchVla.split('，')
      console.log( this.searchVla);
      // console.log(this.queryPageData.data.keys);
    },
    searchVlaBlur() {
      let keysIndex = this.queryPageData.data.keys.length;
      for (let index = 0; index < keysIndex; index++) {
        if (this.queryPageData.data.keys[index] == '' ) {
          // this.searchVla.splice(index,1);
          this.queryPageData.data.keys.splice(index,1);
        }
      }
      console.log('bul',this.queryPageData.data.keys);
    },
    // 搜索
    searchClick() {
        this.recipeOrder.currPage = '';
        this.recipeOrder.pageSize = 10;
        this.recipeOrder.totalCount = '';
        this.recipeOrder.totalPage = '';
        this.recipeOrder.list = [];

        // 搜索条件
        this.queryPageData.page = 0;

        this.finished = false;
        this.loading = true;

        this.queryPageData.page += 1;
        // 进入首页，请求数据
        Api.queryUserCommentRecipePage(this.queryPageData).then((res) => {
          // this.loading = false;
          if (res.data.success) {
            this.loading = false;
            if (res.data.result.totalPage === 0) {
                this.finished = true;
            }
            console.log(res);
            this.recipeOrder.currPage = res.data.result.currPage;
            this.recipeOrder.pageSize = res.data.result.pageSize;
            this.recipeOrder.totalCount = res.data.result.totalCount;
            this.recipeOrder.totalPage = res.data.result.totalPage;
            
            for (let index = 0; index < res.data.result.list.length; index++) {
                // 评分
                let imgUrlArrs = [];
          
                let avgScores = res.data.result.list[index].avgScore
                let decimalPart = avgScores - Math.floor(avgScores);
                let lenghtOr =0;
                let halfFlag = false;
                if (0<decimalPart    && decimalPart < 0.5) {
                      lenghtOr=Math.floor(avgScores);
                } else if (decimalPart >= 0.5 && decimalPart < 0.9) {
                      lenghtOr=Math.floor(avgScores)+1;
                      halfFlag = true;
                } else {
                      lenghtOr=Math.floor(avgScores);
                }
        
                for (let index = 0; index < lenghtOr; index++) {
                      if(index+1== lenghtOr && halfFlag){
                        imgUrlArrs.push({ url: require("../../assets/image/scoreHalf.png") })
                      }else{
                        imgUrlArrs.push( { url: require("../../assets/image/scoreTrue.png") })
                      }
                    
                }
                this.commentLevelImg.push(imgUrlArrs)

                // 用户评分
                let userImgUrlArrs = [];
                for (let index1 = 0; index1 < res.data.result.list[index].commentDetailsLevel; index1++) {
                  userImgUrlArrs.push( { url: require("../../assets/image/scoreTrue.png") })
                }
                res.data.result.list[index].userImgUrlArrs=userImgUrlArrs;
                this.recipeOrder.list.push(res.data.result.list[index]);
                
            }

            console.log("this.recipeOrder.list:",this.recipeOrder.list);
            
            //获取色号值十六进制转换RGB值
            this.recipeOrder.list.forEach(item => {
              let colorObj=colorRgb(item.colorRgb?"#"+item.colorRgb:"");
              console.log("colorRgb:",colorObj);
              item.colorRgb=colorObj.colorRgb;
              item.gcColorRgb=colorObj.gcColorRgb;
            });
            
            console.log(this.queryPageData.page,res.data.result.totalPage);
            if (this.queryPageData.page == res.data.result.totalPage) {
                this.finished = true;
                console.log('数据总长',this.recipeOrder.list.length);
            }
            this.loading = false;
          }
          
        });
    },

    // 搜索配方浏览记录列表
    async searchDetailsBrowsingHistoryList() {
      this.historyFinished=false;
      this.historyLoading=true;
      //清空列表
      this.browsingHistoryList = [];
        // 进入首页，请求数据
      await Api.detailsBrowsingHistoryList({}).then((res) => {
          this.historyCommentLevelImg=[];
          // this.loading = false;
          if (res.data.success) {
            this.historyLoading = false;
            this.historyFinished = true;
            
            if(res.data.result.length>0){
              
              for (let index = 0; index < res.data.result.length; index++) {
                  this.browsingHistoryList.push(res.data.result[index]);

                  // 评分
                let imgUrlArrs = [];
                let avgScores = res.data.result[index].avgScore
                let decimalPart = avgScores - Math.floor(avgScores);
                let lenghtOr =0;
                let halfFlag = false;
                if (0<decimalPart    && decimalPart < 0.5) {
                      lenghtOr=Math.floor(avgScores);
                } else if (decimalPart >= 0.5 && decimalPart < 0.9) {
                      lenghtOr=Math.floor(avgScores)+1;
                      halfFlag = true;
                } else {
                      lenghtOr=Math.floor(avgScores);
                }
        
                for (let index = 0; index < lenghtOr; index++) {
                      if(index+1== lenghtOr && halfFlag){
                        imgUrlArrs.push({ url: require("../../assets/image/scoreHalf.png") })
                      }else{
                        imgUrlArrs.push( { url: require("../../assets/image/scoreTrue.png") })
                      }
                    
                }
                this.historyCommentLevelImg.push(imgUrlArrs)
              }

              //获取色号值十六进制转换RGB值
              this.browsingHistoryList.forEach(item => {
                let colorObj=colorRgb(item.colorRgb?"#"+item.colorRgb:"");
                console.log("colorRgb:",colorObj);
                item.colorRgb=colorObj.colorRgb;
                item.gcColorRgb=colorObj.gcColorRgb;
              });
            }
            

          }else{
             this.historyLoading = false;
          }
          
        });
    },
    // 订单的点击事件(订单详情)
    orderClick(item) {
      const storeStates = storeState()
      storeStates.recipeNo = item.recipeNo;
      //
      storeStates.historyTable = this.activeName;
      storeStates.recipeQueryType = "1";
      this.$router.push({
        path:'/app-h5-cn/page/orders',
        query: {
          ordId: '5'
        }
      }).catch(err => console.log("报错",err))
    },
    onClickTab(name){
      console.log(name,'----');
      if(name == 'myComment'){
        this.searchClick();
      }else{
        this.searchDetailsBrowsingHistoryList();
      }
    },
    onClickLeft() {
      this.$router.push('/app-h5-cn/page/personalCenter');
    },
  },

  beforeRouteEnter(to, from, next) {
    const storeStates = storeState()
    
    console.log(to);
    console.log(from);
    if(from.name==='orders') {
      next(vm => {
        vm.activeName=storeStates.historyTable;
        console.log("22222",vm.activeName);
        if(vm.activeName == 'myComment'){
          vm.searchClick();
        }else{
          vm.searchDetailsBrowsingHistoryList();
        }
      })
    }else {
      next(vm => {
        vm.activeName="browsingHistory";
        console.log("11111");
        vm.searchDetailsBrowsingHistoryList();
      })
    }
  },
  created() {
    this.searchDetailsBrowsingHistoryList();
  }
};
</script>

<style lang="scss" scoped>
.popBtn {
  position: absolute;
  position: fixed;
  bottom: 0;
  z-index: 11;
  width: 100%;
  height: 150px;
  background-color: #fff;
}
.popBtns {
  position: absolute;
  position: fixed;
  bottom: -150px;
  z-index: 11;
  width: 100%;
  height: 150px;
  background-color: #fff;
}
.span-colorOne {
  color: black;
  font-size: 85rem;
}
.search-input {
    padding-top: 3.9rem;
    display: flex;
    width: 100%;
    height: 36px;
    justify-content: space-between;
    background-color: white;
    border-radius: 20px;
    /deep/ .van-cell {
      height: 36px;
    } 
    .search-btn {
        height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: gray;
        div {
            padding: 3px 16px;
            // border: 1px solid red;
            font-size: 16px;
        }
    }
}
.search-dev {
  width: 100vw;
  clear:both;
  .search-dev-order {
    width: 100%;
    height: 100px;
    background-color: yellow;
  }
}
.img-styles {
  width: 15px;
  position: relative;
  top: 3px;
}
.order-box {
  width: 100%;
  display: flex;
  // background-color: red;
  justify-content: center;
  margin-top: .8rem;
  .redios-style {
    padding-right: 1rem;
    margin-left: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .div-box-txt {
    background-color: white;
    border-radius: 5px;
    width: 90%;
    padding-bottom: 1rem;
    overflow:hidden;
    .d1 {
      width: 100%;
      height: 5.6rem;
      display: flex;
      // border: solid 1px red;
      .d1-title1 {
        width: 1.9rem;
        height: 100%;
        background-color: rgb(255, 255, 255);/* 针对不支持渐变的浏览器 */
        // background-image: linear-gradient(rgb(180,-70,-70),rgb(250,0,0),rgb(250,0,0), rgb(180,-70,-70));
        // background-image: linear-gradient(rgba(180,0,0,0.1),rgb(255,255,255));
      }
      .d1-title2 {
        width: calc(100% - 1.9rem);
        height:calc(100% - 2px);
        display: flex;
        // border-bottom: solid .01rem rgb(138, 138, 138);
        // background-color: aquamarine;
        .d1-title1-txt1 {
          width: 100%;
          height: calc(100% - .9rem);
          margin-top: .8rem;
          // background-color: rgb(255, 255, 255);
          
          .img-log {
            height: 2rem;
            margin: .2333rem .5333rem;
            position: absolute;
            right: 1.5rem;
          }
          .txt-span {
            font-size: 1rem;
            font-weight: 600;
            position: relative;
            left: 10px;
            margin-right: 22px;
          }
          .div-end {
            width: 100%;
            height:calc(100% - 1.3rem);
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            top: -.4rem;
            .icon-circle {
              all: initial;
              padding: 1px 5px;
              height: 1.1rem;
              border-radius: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: rgb(254,240,205);
              color:  rgb(248,180,0);
              font-size: .3733rem;
              // padding: 1px 10px;
              padding-left: .2667rem;
              padding-right: .2667rem;
              padding-bottom: .17rem;
              margin-right: .75rem;
              margin-left: .6rem;
            }
              .icon-circle-class {
                font-size: 0.7rem;
                padding-top: 1px;
              }
          }
          .icon-circleTwo {
              all: initial;
              padding: 1px 5px;
              height: 1.1rem;
              border-radius: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: rgb(199,231,242);
              color:  rgb(0,132,184);
              font-size: .3733rem;
              padding-left: .2667rem;
              padding-right: .2667rem;
              padding-bottom: .17rem;
              // padding-top: .1;
              margin-right: .75rem;
          }
          .icon-circleThree {
              all: initial;
              padding: 1px 5px;
              height: 1.1rem;
              border-radius: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: rgb(226,233,206);
              color:  rgb(109,148,25);
              font-size: .3733rem;
              padding-left: .2667rem;
              padding-right: .2667rem;
              padding-bottom: .17rem;
              // padding-top: .1;
              margin-right: .75rem;
              // margin-top: .7rem;
          }
        }
      }
    }
    .d2 {
      height: 5.5rem;
      width: 100%;
      .span-h3-box {
        width: 100%;
        overflow: hidden;//溢出隐藏
        text-overflow: ellipsis;//属性值表示当对象内文本溢出时显示省略标记，省略标记插入的位置是最后一个字符。
        white-space: nowrap;//只保留一个空白，文本不会换行，会在在同一行上继续，直到遇到br标签为止。
        // display: flex;
        // align-items: center;
        // flex-wrap:wrap;
        font-size: .85rem;
        font-weight: 600;
        color: rgb(144,144,144);
        .span-h3 {
          margin-left: 5px;
          font-size: .85rem;
          font-weight: 600;
          color: rgb(144,144,144);
        }
      }
      span {
        font-size: .7rem;
      }
      .van-rows {
        margin-top: .6rem;
        .span-min {
          font-weight: 400;
          color: rgb(191,191,191);
        }
      }
    }
  }
}
.btn-but-style {
    position: fixed;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    // background-color: #fff;
}
.span-colorOne {
  color: black;
}
/deep/ .van-nav-bar__title {
  color: black !important;
  font-size: 1rem;
  font-weight: 600;
}
/deep/ .van-nav-bar .van-icon {
  color: black;
}
/deep/ .van-nav-bar__text {
    color: black !important;
}
/deep/ .van-cell {
  border: #fff;
  width: 100%;
  background: #fff;
  border-radius: 50px;
}
/deep/ .van-field__left-icon .van-icon,
.van-field__right-icon .van-icon {
  font-size: 18px;
}
/deep/ .van-cell-group--inset {
    border-radius: 20px;
}
/deep/ .van-button--info {
  width: 40%;
}
.icon-imgs-style {
  /deep/ .van-icon {
    color: rgb(0, 145, 220);
  }
}
.div-end-d1 {
  width: 70%;
  display: flex;
  margin-left: 5px;
}
.div-end-d2 {
  margin-right: 20px;
}
.dis-div {
  display: flex;
  align-items: center;
}
/deep/ .van-icon-search {
  position: relative;
  top: -4px;
  right: 10px;
}
/deep/ .van-field__control {
  position: relative;
  top: -4px;
}
/deep/ .van-nav-bar__text {
    color: rgb(0, 130, 187) !important;
}
.img-siz-style {
  width: 13px;
  height: 13px;
  position: relative;
  top: 1px;
}
.custom-title {
  margin: 8px;
  text-align:center;
}
</style>